module.exports = __webpack_public_path__ + "static/scale-model-of-hunt-club-farm-in-virginia-beach-virginia-8eefaf7ba64cfcc8341d3a02c9d9ee7b.png";